export const VIDEO_MODEL = "bytedance/seedance-2.5/image-to-video";
export type VideoSettings = {
  prompt: string;
  duration: "5" | "10";
  resolution: "480p" | "720p";
  audio: boolean;
};
export type VideoJob = VideoSettings & {
  id: string;
  sourceId: string;
  created: string;
  state: "running" | "ready" | "failed" | "unknown";
  error?: string;
  output?: { src: string; poster: string; w: number; h: number };
};
export type VideoPrice = { summary: string; details: string };
export function validVideoSettings(value: unknown): value is VideoSettings {
  if (!value || typeof value !== "object") return false;
  const v = value as VideoSettings;
  return (
    typeof v.prompt === "string" &&
    v.prompt.trim().length > 0 &&
    v.prompt.length <= 4000 &&
    ["5", "10"].includes(v.duration) &&
    ["480p", "720p"].includes(v.resolution) &&
    typeof v.audio === "boolean"
  );
}
